<template>
  <div class="wrapper">
    <notice-banner v-if="showBanner" :routerLinkTo="banner.routerLinkTo" :htmlMessage="banner.message"></notice-banner>

    <side-bar type="sidebar" :sidebar-links="sidebarLinks">
      <user-menu></user-menu>
      <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" value="" class="form-control" placeholder="Search...">
        </div>
      </form>
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar :key="keys.topNav" v-if="initialized" :account-data="accountData"></top-navbar>
      
      <dashboard-content :key="keys.content" @click.native="toggleSidebar" @refreshNav="refreshNav()" v-if="initialized" :account-data="accountData">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'
  import moment from 'moment'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { EventBus } from '@/eventBus'

  const NoticeBanner = () => ({
    component: import('./../Views/Components/NoticeBanner.vue')
  })

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu,
      NoticeBanner
    },
    mixins: [toolboxMixin],
    data () {
      return {
        userAuth: {},
        user: {},
        account: {},
        showBanner: false,
        trialDaysLeft: 0,
        banner: {
          routerLinkTo: '/admin/plans',
          message: ''
        },
        sidebarLinks: [],
        accountData: {
          authDetails: {},
          brands: [],
          activeBrand: false
        },
        initialized: false,
        keys: {
          topNav: this.$uuid.v4(),
          content: this.$uuid.v4()
        }
      }
    },
    methods: {
      async init () {
        this.initialized = false
        await this.refreshAccountData()
        this.keys.topNav = this.$uuid.v4()
        this.keys.content = this.$uuid.v4()
        this.initialized = true
        let linksSetup = [
          {
            name: 'Log Out',
            icon: 'ti-power-off',
            path: '/login?logout=true'
          }
        ]
        let linksPendingPlan = [
          {
            name: 'Dashboard',
            icon: 'ti-home',
            path: '/admin/dashboard'
          },
          {
            name: 'Account',
            icon: 'ti-user',
            path: '/admin/account'
          },
          {
            name: 'Log Out',
            icon: 'ti-power-off',
            path: '/login?logout=true'
          }
        ]
        this.userAuth = this.accountData.authDetails.userAuth
        this.user = this.accountData.authDetails.user
        this.account = this.accountData.authDetails.account
        console.log('dboard got account')
        console.log(this.account)
        console.log('phone num')
        console.log(this.userAuth.phoneNumber)
        if (!this.userAuth.phoneNumber || this.account.data.status === 'setup') {
          this.sidebarLinks = linksSetup
          this.showBanner = false
        } else if (this.userAuth.phoneNumber && this.account.data.status === 'pending-plan') {
          this.sidebarLinks = linksPendingPlan
          this.banner.routerLinkTo = '/admin/plans'
          this.banner.message = '<i>Please choose a plan and add a credit card to activate your 30 day trial.</i>'
          this.showBanner = true
        } else if (this.userAuth.phoneNumber && this.account.data.status === 'active-until') {
          let activeUntil = moment(this.account.data.activeUntil.seconds * 1000).format('l')
          this.sidebarLinks = this.$sidebar.sidebarLinks
          this.banner.routerLinkTo = '/admin/change-plan'
          this.banner.message = '<i>Your account is active until ' + activeUntil + '.</i>'
          this.showBanner = true
        } else { // assumed 'active'
          this.sidebarLinks = this.$sidebar.sidebarLinks
          this.showBanner = false
        }
        // if (this.userAuth.phoneNumber && this.account.data.status === 'trial') {
        //   console.log('trial ends')
        //   console.log(this.account.data.trialEndsAt)
        //   let trialEndsAt = moment(this.account.data.trialEndsAt.seconds * 1000)
        //   this.trialDaysLeft = Math.max(0, trialEndsAt.diff(moment(), 'days'))
        //   console.log('days left in trial: ' + this.trialDaysLeft)
        //   this.showBanner = true
        // }
      },
      async listenAccountUpdates (accountId) {
        db.collection('accounts').doc(accountId)
        .onSnapshot(doc => {
          let account = {
            id: doc.id,
            data: doc.data()
          }
          this.accountData.authDetails.account = account
        })
      },
      async refreshAccountData () {
        var data = {}
        data.authDetails = await this.getAuthDetails()
        data.brands = []
        data.activeBrand = false
        let qs = await db.collection('brands').where('accountId', '==', data.authDetails.account.id).orderBy('name').get()
        for (const doc of qs.docs) {
          data.brands.push({
            id: doc.id,
            data: doc.data()
          })
          if (data.activeBrand === false || data.authDetails.user.data.activeBrandId === doc.id) {
            data.activeBrand = {
              id: doc.id,
              data: doc.data()
            }
          }
        }
        this.accountData = data
        console.log('accountData', this.accountData)
        this.listenAccountUpdates(this.accountData.authDetails.account.id)
        console.log('refreshed account data', this.accountData)
      },
      refreshNav () {
        alert('refreshing nav')
        this.init()
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
        EventBus.$on('auth-refreshed', () => {
          this.init()
        })
        EventBus.$on('reload-account-data-silent', () => {
          this.refreshAccountData()
        })
      })
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue